import { render, staticRenderFns } from "./StorageCardList.vue?vue&type=template&id=38fa1d34&"
import script from "./StorageCardList.vue?vue&type=script&lang=js&"
export * from "./StorageCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports